import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBackgroundJobs } from "@/contexts/BackgroundJobsContext";
import { JobResultsPanel } from "./JobResultsPanel";

export function JobsStatusIcon() {
  const [open, setOpen] = useState(false);
  const { activeCount, jobs } = useBackgroundJobs();

  const hasJobs = jobs.length > 0;

  return (
    <>
      <div className="relative inline-flex">
        <Button
          variant="ghost"
          size="icon"
          title="Procesos en segundo plano"
          onClick={() => setOpen(true)}
        >
          <RefreshCw
            className={`h-5 w-5 ${activeCount > 0 ? "animate-spin" : ""}`}
          />
          <span className="sr-only">Procesos en segundo plano</span>
        </Button>
        {activeCount > 0 && (
          <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center bg-amber-500 text-[10px] font-bold text-white pointer-events-none" style={{ borderRadius: "3px" }}>
            {activeCount > 9 ? "9+" : activeCount}
          </span>
        )}
        {activeCount === 0 && hasJobs && (
          <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-green-500 pointer-events-none" />
        )}
      </div>
      <JobResultsPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
